import {Model} from "./Model";
import {Language} from "./Language";

export class Metadata {
  identifier: string;
  pos: string;
  modelYear: string;
  model: Model;
  language: Language;
  info: string;

  constructor(identifier: string, pos: string, modelYear: string, model: Model, language: Language, info: string) {
    this.identifier = identifier;
    this.pos = pos;
    this.modelYear = modelYear;
    this.model = model;
    this.language = language;
    this.info = info;
  }
}
